module.exports = __webpack_public_path__ + "static/media/documentpayslip.5c169e3e.svg";